import React from "react";
import {
  Brain,
  Compass,
  Gift,
  Globe,
  Handshake,
  HousePlug,
  Image,
  Laptop2,
  Package,
  Rocket,
  Star,
  Target,
  TrendingUp,
  Truck,
} from "lucide-react";
import { Badge } from "components/UI/Badge";
import { ICapability } from "Interfaces/interface.informationalPages";

const KeyCapabilitiesPanel: React.FC = () => {
  const capabilities: ICapability[] = [
    {
      icon: <Rocket className="w-8 h-8 text-white" />,
      title: "Built by the Bold",
      description: "Youth-led team solving real problems",
      hasTryAI: true,
      tryAIPath: "/",
    },
    {
      icon: <Target className="w-8 h-8 text-white" />,
      title: "Strategic Gifting",
      description: "Gifting aligned with event & ROI",
      hasTryAI: true,
      tryAIPath: "/mockup-tool",
    },
    {
      icon: <TrendingUp className="w-8 h-8 text-white" />,
      title: "Trend-First Approach",
      description: "No repeats. Always what's relevant",
    },
    {
      icon: <HousePlug className="w-8 h-8 text-white" />,
      title: "In-House Creativity",
      description: "Faster, smarter, in-house ideation",
    },
    {
      icon: <Star className="w-8 h-8 text-white" />,
      title: "Experience over Margins",
      description: "Every order built to wow, first",
      hasTryAI: true,
      tryAIPath: "/",
    },
    {
      icon: <Laptop2 className="w-8 h-8 text-white" />,
      title: "Tech-Powered Ease",
      description: "Tools that remove your manual work",
      hasTryAI: true,
      tryAIPath: "/mockup-tool",
    },
    {
      icon: <Globe className="w-8 h-8 text-white" />,
      title: "Nationwide, Not Local",
      description: "Centralized ecosystem, pan-India scale",
    },
    {
      icon: <Handshake className="w-8 h-8 text-white" />,
      title: "Win-Win-Win Culture",
      description: "You, us, and team. Everyone wins",
    },
  ];

  const iconBgVariants = [
    "from-blue-500 to-blue-700",
    "from-purple-500 to-purple-700",
    "from-green-500 to-green-700",
    "from-indigo-500 to-indigo-700",
  ];

  return (
    <section className="relative py-10 md:py-20 px-4 overflow-hidden">
      {/* Background Blur Elements */}

      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <Badge className="bg-primary-gradient  flex justify-center items-center">
            <Compass className="h-4 w-4 mr-2 text-white " />
            <span className="text-white">Powered by Purpose</span>
          </Badge>
          <h2 className="text-4xl md:text-5xl p-2 font-inter font-bold mb-4 text-secondary-gradient">
            Beyond Traditional Gifting
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto">
            We don't just deliver gifts. We craft experiences rooted in
            strategy, creativity, and care.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className=" relative overflow-hidden border-0 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 bg-white rounded-xl"
            >
              {/* Gradient Background */}
              <div
                className={`absolute inset-0 bg-gradient-to-br ${
                  iconBgVariants[index % iconBgVariants.length]
                } opacity-5`}
              ></div>

              <div className="p-8 relative text-center">
                <div className="flex justify-center items-center">
                  <div
                    className={`w-14 h-14 bg-gradient-to-br ${
                      iconBgVariants[index % iconBgVariants.length]
                    } rounded-2xl flex items-center justify-center mb-6`}
                  >
                    {capability.icon}
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {capability.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4">
                  {capability.description}
                </p>
                {/* {capability.hasTryAI && (
                  <ButtonTertiary
                    icon={<Sparkles size={18} />}
                    onClick={() =>
                      capability.tryAIPath && navigate(capability.tryAIPath)
                    }
                  />
                )} */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyCapabilitiesPanel;
